import { Button } from 'design-system';
import type { IntelSummary } from 'design-system';
import { ArrowUpRight } from 'lucide-react';

import { useChatActions } from '../../../state/useChat';

const buildSampleQuestions = (signal: IntelSummary): string[] => [
  `What does this mean for ${signal.region}?`,
  `Why is this rated ${signal.importance} importance?`,
  `Summarize "${signal.title}" in simple terms`
];

/**
 * Shown at the top of the chat when a Morning Intel signal is selected
 * (`?signal=` on the Home/Morning Intel routes): the signal's name and
 * description, plus a few sample questions that send straight into the
 * existing chat thread. Does not replace or reset the chat itself.
 */
const SignalContextBanner = ({ signal }: { signal: IntelSummary }) => {
  const { sendMessage } = useChatActions();
  const sampleQuestions = buildSampleQuestions(signal);

  return (
    <div className='mx-4 mt-4 shrink-0 rounded-[3px] border border-[rgba(140,124,240,0.32)] border-l-[3px] border-l-[#8c7cf0] bg-[rgba(140,124,240,0.12)] px-3 py-3'>
      <p className='text-[13px] leading-[1.45] font-extrabold text-[#f3f2ed]'>{signal.title}</p>
      <p className='mt-1 text-xs leading-[1.45] text-[#9fa0ad]'>{signal.blurb}</p>
      <div className='mt-3 flex flex-wrap gap-2'>
        {sampleQuestions.map(question => (
          <Button
            key={question}
            className='h-auto justify-between gap-2 rounded-[3px] border-[#3d3f4c] bg-[#17181f] px-3 py-2 text-left text-xs font-medium text-[#f3f2ed] hover:border-[#8c7cf0] hover:bg-[#20222c]'
            size='sm'
            variant='outline'
            onClick={() => {
              sendMessage(question);
            }}
          >
            <span>{question}</span>
            <ArrowUpRight
              aria-hidden='true'
              className='size-3.5 shrink-0 text-[#66677a]'
              data-icon='inline-end'
            />
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SignalContextBanner;
